import React, { Component } from "react";
import { dateFormat } from "../../utils/dateFormat";

import { FormControl, FormGroup, Button } from 'react-bootstrap';

class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      versionA: null,
      versionB: null
    };
  }

  componentWillReceiveProps({versions}) {
    if (versions && versions.length > 0 && this.state.versionA === null) {
      this.setState({
        versionA: versions[0].version,
        versionB: versions.length > 1 ? versions[1].version : versions[0].version
      });
    }
  }

  onChange = (event, n) => {
    if (n === "A") {
      this.setState({
        versionA: event.target.value
      });
    } else if (n === "B") {
      this.setState({
        versionB: event.target.value
      });
    } else {
      return;
    }
  }

  render() {
    return (
      <div className="compare-menu">
        <FormGroup className="version-group compare-select-group">
          <FormControl
            componentClass="select"
            placeholder="select"
            className="version-selector compare-select-button"
            value={this.state.versionA}
            onChange={event => this.onChange(event, "A")}>
            {this.props.versions.map(version => {
              return (<option key={version.name + version.version} value={version.version}>{version.version} - {dateFormat(version.createdAt)}</option>)
            })}
          </FormControl>
        </FormGroup>
        <FormGroup className="version-group compare-select-group">
          <FormControl
            componentClass="select"
            placeholder="select"
            className="version-selector compare-select-button"
            value={this.state.versionB}
            onChange={event => this.onChange(event, "B")}>
            {this.props.versions.map(version => {
              return (<option key={version.name + version.version} value={version.version}>{version.version} - {dateFormat(version.createdAt)}</option>)
            })}
          </FormControl>
        </FormGroup>
        <Button className="compare-select-button" onClick={() => this.props.compare(this.state.versionA, this.state.versionB)}>Compare</Button>
      </div>
    )
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/swaggers-diff/Menu.js